import React, { Component } from 'react';
// import classnames from 'classnames';
import styles from './styles.module.scss';

class LoadingSpinner extends Component {
  render() {
    return (
      <div className={styles.wrapper}>
        <div className={styles.spinner}>
          <div className={styles.doubleBounce1} />
          <div className={styles.doubleBounce2} />
        </div>
      </div>
    );
  }
}

export default LoadingSpinner;
